<!--
* UIID: UI-DLB-SRM-111
* UI Name: FlatFile Layout List
* Modify Date: 2020/04/14
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        FlatFile Layout List
        <v-spacer />
        <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon>
      </v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup body-->
      <v-card-text class="content-section pa-0">
        <v-row class="content-covering">
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pb-search">
              <v-col cols="4" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0">
                <div class="popup-info" v-show="customerSelect">
                  <v-label>Customer</v-label>
                  <div class="dv-select-img">
                    <v-select solo class="select-flatfile"></v-select>
                  </div>
                </div>
              </v-col>
              <v-col cols="4" class="pa-0">
                <v-text-field
                  v-model="search"
                  class="search-matched-map-list-button custom-form-component search-button search-field-color"
                  outlined
                  dense
                  solo
                  hide-details
                  placeholder="Search"
                  append-icon="fas fa-search"
                  height="30"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="data-table-flat-file-list ma-0">
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :search="search"
                  :fixed-header="true"
                  :hide-default-footer="true"
                  :headers="map_table_header"
                  :items="ffList"
                  class="analyzed-layout-table matched-map-list flatfile-layout-list-data-table"
                  disable-pagination
                  disable-sort
                  height="186"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center align-radio">
                          <input
                            v-model="selected_map"
                            :value="item.FFL_FILE_NAME"
                            @click="selectFlatFile(item)"
                            name="matched-map"
                            type="radio"
                          />
                        </td>
                        <td class="flat-file-layout-col text-left">
                          <a @click="downloadFlatFile(item)">{{ item.FFL_FILE_NAME }}</a>
                        </td>
                        <td class="customer-col text-left">{{ item.MST_CUST_NM }}</td>
                        <td class="type-col text-left">{{ item.FFL_FRMT_TP_NM }}</td>
                        <td class="version-col text-center">{{ item.FFL_VERSION }}</td>
                        <td class="text-center">{{ item.FFL_UPD_DT }}</td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <!-- [S]  Popup buttons-->
      <v-card-text class="footer-display">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <v-btn class="dialog-btn btn-delete ma-0 float-right" tile dark @click="removeDialog">
              <v-icon small color="white" class="mr-1">fa fa-times</v-icon
              >{{ $t('btn.common.close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup buttons-->
    </v-card>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
// import controlData from '../Data/asset-creation/data_control.json'

export default {
  components: {
    DialogDrag,
  },
  computed: {
    ...mapState('srmlist', {
      ffList: 'ffList',
    }),
  },
  // props: ['id', 'title', 'options', 'eventCb', 'selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    selectFile: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    fileSelected: String,
  },
  name: 'flatFile-layout-list',
  data: () => ({
    search: '',
    selected_map: '',
    userRow: 'admin',
    customerSelect: false,
    layoutMatchingViewArr: [],
    // map_table_data : controlData[0].matched_map_table_data,
    map_table_header: [
      { value: '', text: 'Select', width: 60 },
      { value: 'FFL_FILE_NAME', text: 'FlatFile Layout Name', width: 200 },
      { value: 'MST_CUST_NM', text: 'Customer', width: 100 },
      { value: 'FFL_FRMT_TP_NM', text: 'Type', width: 110 },
      { value: 'FFL_VERSION', text: 'Version', width: 70 },
      { value: 'FFL_UPD_DT', text: 'Update Date', width: 145 },
    ],
    masterSearchItems: {
      header: ['ADMIN_YN', 'CUST_ID'],
      data: [
        {
          ADMIN_YN: '',
          CUST_ID: '',
        },
      ],
    },
    flatFileDownloadItems: {
      header: ['FILE_ID', 'ATF_FILE_NAME'],
      data: [
        {
          SAVE_NAME: '',
          FILE_ID: '',
          ATF_FILE_NAME: '',
        },
      ],
    },
  }),

  methods: {
    queryReferenceFilesList() {
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log('--------- queryReferenceFilesList ----------');
      this.masterSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
      this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('srmlist/queryFlatFileLayoutList', this.masterSearchItems).then(() => {
        console.log('--------- Finished to process ----------');
        console.log(this.ffList);
      });
    },
    downloadFlatFile(item) {
      this.flatFileDownloadItems.data[0].SAVE_NAME = item.FFL_FILE_NAME;
      this.flatFileDownloadItems.data[0].FILE_ID = item.FILE_ID;
      this.flatFileDownloadItems.data[0].ATF_FILE_NAME = item.FFL_FILE_NAME;
      Store.dispatch('common/DownloadFileFromServer', this.flatFileDownloadItems).then(() => {
        console.log('--------- Finished to process ----------');
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },

    selectFlatFile(item) {
      if (!this.options.item.readOnly) {
        this.removeDialog({});
        this.selectFile(item);
      }
    },

    selectDialog(obj) {
      this.dragStart(obj);
    },

    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },

    selectMap() {
      this.srm_item.map = this.selected_map;
      this.removeDialog({ id: this.id });
    },

    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
  },

  created() {
    if (this.userRow === 'admin') {
      this.customerSelect = true;
    }
    if (this.fileSelected !== undefined && this.fileSelected !== null) {
      this.selected_map = this.fileSelected;
    }

    this.queryReferenceFilesList();
  },
};
</script>

<style>
.analyzed-layout-dialog.matched-map-list {
  width: 1075px !important;
  height: auto !important;
}
/* Remove unuse code
.tab-text {
  padding-left: 5px !important;
  justify-content: left !important;
}
.v-tabs.theme--dark > .v-item-group {
  background-color: #424242 !important;
}
.v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
  background-color: #424242 !important;
}
 */
.analyzed-layout-dialog
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  width: 190px;
  margin: 0px !important;
}
.analyzed-layout-dialog .search-button {
  margin: 0px !important;
}
.analyzed-layout-table a {
  font-weight: bold;
  text-decoration: underline;
  color: #0082ba !important;
}
.analyzed-layout-table table td {
  font-weight: normal !important;
  font-size: 11px !important;
}

.pb-search {
  padding-bottom: 5px;
}

.content-covering {
  margin: 0px !important;
  height: 275.5px;
  padding: 20px 15px 15px;
  background: #fafcff;
  border: 1px solid #f0f7fb;
  box-sizing: border-box;
  border-radius: 3px;
}

.footer-display {
  padding: 10px 0px 0px;
}
.dv-select-img
  > .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
  padding: 0px;
  margin: 0px;
  border: 1px solid #d4d5d7;
  height: 30px;
  border-radius: 1px;
  min-height: 30px;
  box-sizing: border-box;
  box-shadow: none;
}

.dv-select-img .v-text-field__details {
  max-height: 0px !important;
  min-height: 0px !important;
  margin: 0px !important;
  padding: 0px;
}
.dv-select-img .v-input__control {
  min-height: 25px !important;
}
.dv-select-img {
  float: right;
  padding: 0px 10px;
}
.popup-info {
  padding: 0px 0px 0px 20px;
  display: flex;
}
.popup-info .v-label {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #000000 !important;
}
.popup-info label,
.custom-form-component input,
.select-flatfile {
  font-size: 12px !important;
}
.search-field-color fieldset {
  border: 1px solid #d4d5d7 !important;
}
.data-table-flat-file-list .v-data-table__wrapper {
  background: #fafcff;
}
.data-table-flat-file-list .v-data-table--fixed-header thead th {
  background: #e4e6e8 !important;
  height: 25px !important;
}

.data-table-flat-file-list .v-data-table--fixed-header thead th span {
  font-size: 11px;
}

.matched-map-list .v-data-table__wrapper {
  overflow-y: hidden;
}
</style>
